export default __webpack_public_path__ + "static/media/024-wash hands.8aedaa35.svg";